import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router";
import { getImagesUrl } from "../../redux/common";
import FragmentCardContent from "./FragmentCardContent";

export function ElementMissingContext() {
    const navigate = useNavigate();

    return <>
        <FragmentCardContent 
            image={`${getImagesUrl()}/missing-context.webp`}
            title="Informação para construção da pagina não disponivel"
            description={
                <Box>
                    <Button onClick={() => navigate(-1)}>Voltar</Button>
                    <Button onClick={() => navigate("/")}>Inicio</Button>
                </Box>
            }
        />
    </>;
}